'use client';

import { useSyncExternalStore } from 'react';

import {
  SELECTED_WORKSPACE_CHANGED_EVENT,
  readSelectedWorkspaceIdSnapshot,
} from './workspace-selection';

function subscribeSelectedWorkspaceId(onStoreChange: () => void) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const listener = () => onStoreChange();

  window.addEventListener(SELECTED_WORKSPACE_CHANGED_EVENT, listener);
  window.addEventListener('storage', listener);

  return () => {
    window.removeEventListener(SELECTED_WORKSPACE_CHANGED_EVENT, listener);
    window.removeEventListener('storage', listener);
  };
}

export function useSelectedWorkspaceIdSnapshot(tenantId?: string | null) {
  return useSyncExternalStore(
    subscribeSelectedWorkspaceId,
    () => readSelectedWorkspaceIdSnapshot(tenantId),
    () => ''
  );
}
